'use client';

import { createTheme } from '@mantine/core';
import base from './base';

const theme = createTheme({
  // colorScheme: 'dark',
  primaryColor: 'blackroomBlack',
  ...base,
  colors: {
    ...base.colors,
    /* ******************* DARK MODE VARIANTS OF SHARED COLORS ****************** */

    // Used as a primary background color
    blackroomGray: [
      '#edf3f8',
      '#d5d9dc',
      '#bbc0c3',
      '#a1a6aa',
      '#878d92',
      '#6d7379',
      '#545a5f',
      '#3c4144',
      '#23272a',
      '#070e13',
    ],

    /* ************************** THEME SPECIFIC COLOR ************************** */

    // Used for hovering primary elements or input backgrounds (ex: menu items)
    blackroomDarkGray: [
      '#ebf3fb',
      '#d3d9de',
      '#bac0c5',
      '#9fa7ad',
      '#848d94',
      '#6b747b',
      '#525a60',
      '#3a4045',
      '#21272c',
      '#050e15',
    ],
  },
  // TODO(migration): handle this elsewhere
  // components: {
  //   Title: {
  //     styles: (t) => ({
  //       root: {
  //         color: t.colors.blackroomWhite,
  //       },
  //     }),
  //   },
  // },
});

export default theme;
